import { Component } from '@angular/core';
import { NgClass } from '@angular/common';
import {
  resolveAvatarColorClass,
  resolveInitials,
} from '@core/utils/initial-avatar.util';

@Component({
  selector: 'app-contact-name-cell',
  standalone: true,
  imports: [NgClass],
  template: `
    <div class="flex min-w-0 items-center gap-3">
      <span
        class="flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-xs font-semibold text-white"
        [ngClass]="colorClass"
        aria-hidden="true">
        {{ initials }}
      </span>
      <span class="truncate text-body2 text-neutral-950">{{ displayName }}</span>
    </div>
  `,
})
export class ContactNameCellComponent {
  /** Set by NGL DynamicRenderer. */
  rowData!: {
    id?: string;
    firstName?: string | null;
    lastName?: string | null;
    displayName?: string | null;
    email?: string | null;
  };

  get displayName(): string {
    return (
      this.rowData?.displayName?.trim() ||
      [this.rowData?.firstName, this.rowData?.lastName]
        .filter(Boolean)
        .join(' ') ||
      this.rowData?.email ||
      ''
    );
  }

  get initials(): string {
    return resolveInitials({
      firstName: this.rowData?.firstName,
      lastName: this.rowData?.lastName,
      name: this.rowData?.displayName,
      email: this.rowData?.email,
    });
  }

  get colorClass(): string {
    return resolveAvatarColorClass(this.rowData?.id ?? '');
  }
}
